import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { FloatingLabelProps } from './types';

type FloatingLabelStyleProps = Pick<FloatingLabelProps, 'active' | 'disabled' | 'hasError' | 'leftOffset'>;

const floatingLabelBase = css`
  font-size: ${theme.fontSize(16)};
  line-height: 1;
  padding: ${theme.spacing(0, 0.5)};
  pointer-events: none;
  position: absolute;
  top: 0;
  left: ${theme.spacing(1.5)};
  transform-origin: left top;
  transition: color 200ms ease-out, transform 150ms ease-out;
`;

const floatingLabelDefaultColor = css`
  color: ${theme.colors.neutral50};
`;

const floatingLabelDisabledColor = css`
  color: ${theme.colors.neutral20};
`;

const floatingLabelHasErrorColor = css`
  color: ${theme.colors.status.critical};
`;

const floatingLabelActive = css`
  transform: scale(0.75) translateY(-65%);

  &::before {
    content: '';
    width: 100%;
    height: calc(100% + 4px);
    background: white;
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    z-index: -1;
  }
`;

const floatingLabelInactive = css`
  transform: scale(1) translateY(11px);
`;

const floatingLabelInactiveWithOffset = css`
  transform: scale(1) translate(calc(var(--floating-label-left-offset, 0px) + 8px), 11px);
`;

export const getFloatingLabelClassName = ({ leftOffset, active, disabled, hasError }: FloatingLabelStyleProps) =>
  cx(
    floatingLabelBase,
    disabled ? floatingLabelDisabledColor : hasError ? floatingLabelHasErrorColor : floatingLabelDefaultColor,
    active ? floatingLabelActive : leftOffset ? floatingLabelInactiveWithOffset : floatingLabelInactive
  );

export const FloatingLabelStyles = {
  floatingLabel: getFloatingLabelClassName,
};
